import {
  DefaultQueryParams,
  environmentBuilder,
  GameLiveConnection,
  parseQuery,
  popupStore,
} from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';

import { gameService } from './GameService';
import { gameName, socketGamePath } from '../enums';
import { gameStore } from '../store';

let start = Number(new Date());
let timeoutId;
const pingInterval = 700;
export class GameConnection extends GameLiveConnection {
  constructor(url) {
    super(url);
  }

  async sendGameGetInitialState(isFirst = true) {
    if (isFirst) {
      this.executeConnections();
    }
    await this.sendInitial();
  }

  async sendInitial() {
    const { gameTypeId } = gameConfigStore;
    const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);
    await super.sendGetInitialState({ partnerId, gameTypeId });
  }

  handleInitialResult(data) {
    if (!data || !data.roundInfo) {
      const { gameTypeId } = gameConfigStore;
      const { [DefaultQueryParams.PartnerId]: partnerId } = parseQuery(window.location.search);

      setTimeout(() => {
        super.sendGetInitialState({ partnerId, gameTypeId }).then(() => {});
      }, 500);
    } else {
      gameService.onGetInitialStateResult.call(gameService, data);
    }
  }

  sendPing() {
    start = Number(Date.now());
    gameStore.setIsPongReceived(false);
    super.invoke('Ping');
    timeoutId = setTimeout(() => {
      if (!gameStore.isPongReceived) {
        popupStore.toggleSlowConnection(true);
      }
    }, pingInterval);
  }

  getPong() {
    const currentTime = Number(Date.now()) - start;
    gameStore.setIsPongReceived(true);
    if (currentTime > pingInterval) {
      popupStore.toggleSlowConnection(true);
      timeoutId && clearTimeout(timeoutId);
    } else {
      popupStore.toggleSlowConnection(false);
    }
  }

  executeConnections() {
    // INITIAL
    super.onGetInitialStateResult(this.handleInitialResult.bind(this));
    // INITIAL

    super.onGameOpen();
    super.onFreeBetEnded();
    super.onBalanceUpdate();
    super.onFreeBetAwarded();
    super.onLobbyUsersCount();
    super.onPing(this.getPong);
    super.onGetBalanceResult();
    super.onGetUserBetsHistoryResult();
    super.onMaintenanceNotify();
    super.onFreeBetCountUpdate();
    super.onClose(gameService.handleConnectionError.bind(gameService));
    super.onBetsClosed(gameService.handleBetsClosed.bind(gameService));
    super.onRoundFinished(gameService.handleRoundFin.bind(gameService), {
      notificationDelay: 5000,
    });
    super.onDoBetResult(gameService.handleDoBetResult.bind(gameService));
    super.onRoundStarted(gameService.handleRoundStart.bind(gameService));
    super.onReconnecting(gameService.handleReconnecting.bind(gameService));
    super.onReconnected(gameService.handleReconnected.bind(gameService));
    super.onDoBetResultValidation(gameService.handleDoBetResultValidation.bind(gameService));
    // Tournament listeners
    super.onUserTournamentInfo();
    super.onGetTournamentInfoResult();
    super.onGetTournamentBalanceResult();
  }
}

const { socketUrl } = environmentBuilder(gameName);

const url = (path) => ({ url: `${socketUrl}${path}` });

export const gameLiveConnection = new GameConnection(url(socketGamePath));
